class VideoAnim extends HTMLElement {
  constructor() {
    super();
    this.videoAnimBanner = this.querySelector(".video-anim--banner");
    this.videoAnimContainer = this.querySelector(".video-anim--container");
    this.videoContainer = this.querySelector(".media-banner-container");
    this.videoContent = this.querySelector(".media-banner-text-content");
    this.videoContentWidth = this.querySelector(".media-banner-text-inner");
    this.cornerRound = this.getAttribute("data-corner-radius");
    this.scrollHandler = this.handleScroll.bind(this);
    this.resizeHandler = this.handleResize.bind(this);
    this.marginTop = 0;
    this.animationFrame = null;
  }

  connectedCallback() {
    this.calculateMarginTop();
    window.addEventListener("scroll", this.requestScrollUpdate, {
      passive: true,
    });
    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.requestScrollUpdate);
    window.removeEventListener("resize", this.resizeHandler);
    cancelAnimationFrame(this.animationFrame);
  }

  requestScrollUpdate = () => {
    if (!this.animationFrame) {
      this.animationFrame = requestAnimationFrame(() => {
        this.handleScroll();
        this.animationFrame = null;
      });
    }
  };

  calculateMarginTop() {
    const windowHeight = window.innerHeight;
    const videoContainerHeight = this.videoContainer.offsetHeight;
    this.marginTop =
      windowHeight > videoContainerHeight
        ? (windowHeight - videoContainerHeight) / 2
        : 0;
  }

  handleResize() {
    this.calculateMarginTop();
    this.handleScroll(); // Apply changes immediately after resizing
  }

  handleScroll() {
    const rect = this.videoContainer.getBoundingClientRect();
    const parentRect = this.videoAnimBanner.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const halfWindowHeight = windowHeight / 2;

    const progress = Math.min(
      Math.max((windowHeight - parentRect.top) / windowHeight, 0),
      1
    );
    const clipValue = 25 - progress * 25;

    this.videoContainer.style.clipPath = `inset(0 ${clipValue}% 0 ${clipValue}% round ${this.cornerRound})`;

    if (progress >= 0.9) {
      this.videoContent.classList.add("slide-in");
      const normalized = Math.min(1, Math.max(0, (progress - 0.9) / 0.1));
      const normalizedOpacity = (progress - 0.9) / 0.1;
      const translateValue = 18 - normalized * 18;
      if (this.videoContentWidth) {
        this.videoContentWidth.style.transform = `translateY(${translateValue}%)`;
      }
      this.videoContent.style.opacity = `${normalizedOpacity}`;
    } else {
      this.videoContent.classList.remove("slide-in");
      if (this.videoContentWidth) {
        this.videoContentWidth.style.transform = "translateY(0%)";
      }
      this.videoContent.style.opacity = 0;
    }

    if (rect.top <= halfWindowHeight && rect.bottom >= halfWindowHeight) {
      this.videoAnimContainer.style.position = "sticky";
      this.videoAnimContainer.style.top = `${this.marginTop}px`;
    }
  }
}

customElements.define("video-anim", VideoAnim);
